export const handleRating=(i)=>{
    return [...Array(5).keys()].map((_,index)=>{
        if((index+1)<=i) return {star:true}
        else return {star:false}
    })
}